module.exports = __webpack_public_path__ + "static/img/cont34 (5).aa18ca2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont34 (5).jpg
// module id = c77q
// module chunks = 0